import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AbilityModule } from 'ability';
import { I18NextModule, I18NextPipe } from 'angular-i18next';
import { MbsUiKitModule } from 'mbs-ui-kit';
import { AlertType } from 'mbs-ui-kit/alert/alert.model';
import { ModalComponent } from 'mbs-ui-kit/modal/modal.component';
import { MbsPopupType } from 'mbs-ui-kit/utils/enums/mbs-popup-enum';
import { AgentType } from 'mbs-ui-shared@models/Computer';

@UntilDestroy()
@Component({
  selector: 'mbs-bulk-agent-install-confirmation-modal-component',
  templateUrl: './computers-bulk-install-agent-confirmation-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, I18NextModule, FormsModule, ReactiveFormsModule, MbsUiKitModule, AbilityModule, NgbTooltipModule]
})
export class ComputersBulkInstallAgentConfirmationModalComponent {
  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;
  public readonly mbsPopupType = MbsPopupType;
  public readonly agentType = AgentType;
  public readonly alertType = AlertType;
  public agent: AgentType;

  constructor(private i18nPipe: I18NextPipe) {}

  public get agentName(): string {
    return this.i18nPipe.transform(`shared:products.${this.agent}`);
  }

  public get confirmationQuestion(): string {
    return this.i18nPipe.transform('shared:computers.modals.bulkInstallAgentQuestion', { param: this.agentName });
  }
}
